import lrListTable from './_src/lrListTable.vue'
lrListTable.install = function(Vue) {
  Vue.component(lrListTable.name, lrListTable)
}
export default lrListTable